import { Box } from '@origin-digital/layout';
import { dobDay, onlyNumeric } from '@origin-digital/normalize';
import { AlertBox, Button, TextField } from '@origin-digital/style-guide';
import * as React from 'react';
import { ChangeEvent, FormEvent } from 'react';
import { AuthCard } from '../../../../components/Card';
import { Heading } from '../../../../components/Heading';
import { InfoText } from '../../../../components/InfoText';
import { BackButton } from '../../sub-components/back-button/BackButton';
import { Copy } from './Interfaces';
import { Page } from '../../../../components/Page';

interface FindEmailViewProps {
  onLastNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onLastNameBlur: (event: ChangeEvent<HTMLInputElement>) => void;
  onDOBChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onDOBBlur: (event: ChangeEvent<HTMLInputElement>) => void;
  dobError: string;
  onPostcodeChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onPostcodeBlur: (event: ChangeEvent<HTMLInputElement>) => void;
  postcodeError: string;
  lastNameError: string;
  onSubmit: (event: FormEvent<HTMLButtonElement>) => void;
  spinner: boolean;
  alertBoxError: string;
  copy: Copy;
  history: any;
}

const FindEmailView: React.FC<FindEmailViewProps> = ({
  onLastNameChange,
  onLastNameBlur,
  onDOBChange,
  onDOBBlur,
  onPostcodeChange,
  onPostcodeBlur,
  postcodeError,
  onSubmit,
  dobError,
  spinner,
  alertBoxError,
  lastNameError,
  copy,
  history,
}) => {
  return (
    <Page>
      <AuthCard>
        <form>
          <Heading text={copy.headingText} />
          <InfoText text={copy.infoText} />
          {alertBoxError && (
            <Box marginBottom={8}>
              <AlertBox type="error" message={alertBoxError} markdown={true} />
            </Box>
          )}
          <TextField
            label="Last name"
            name="lastName"
            disableIcon={!lastNameError}
            onChange={onLastNameChange}
            onBlur={onLastNameBlur}
            error={lastNameError}
            touched={true}
            helpText={'Please enter the last name of the primary account holder'}
          />
          <TextField
            label="Date of birth"
            name="dateOfBirth"
            showCharacterCount={false}
            disableIcon={!dobError}
            maxLength={10}
            maxLengthExcludeChars={['/']}
            helpText={'DD/MM/YYYY'}
            transform={dobDay}
            type="tel"
            onChange={onDOBChange}
            onBlur={onDOBBlur}
            error={dobError}
            touched={true}
          />
          <TextField
            label="Postcode"
            name="postcode"
            type="tel"
            transform={onlyNumeric}
            showCharacterCount={false}
            disableIcon={!postcodeError}
            maxLength={4}
            helpText={'Please enter the postcode for your billing address'}
            onChange={onPostcodeChange}
            onBlur={onPostcodeBlur}
            error={postcodeError}
            touched={true}
          />
          <Button
            text="Look for my email"
            type="submit"
            data-id="look-for-email"
            name="lookForMyEmail"
            block={true}
            onClick={onSubmit}
            spinner={spinner}
          />
          <BackButton history={history} />
        </form>
      </AuthCard>
    </Page>
  );
};

export { FindEmailView };
